import React from 'react';
import Lightbox from 'react-images';

import './ContactGallery.scss';

class ContactGallery extends React.Component {
  constructor() {
    super();
    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    }
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  };

  openLightbox = (event) => {
    event.preventDefault();
    this.setState({
      currentImage: parseInt(event.currentTarget.id),
      lightboxIsOpen: true,
    });
  };

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  };

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  };

  renderGallery = () => {
    if (this.props.branchActive === 1) {
      let imgIndex = 0;

      let imagesArray = [];

      this.props.galleryImgs_ov.forEach((img, index) => {
        if (index === 0) return;
        imagesArray.push({src: img})
      });

      return (
        <section className="contactGallery">
          <div className="container_1000">
            <div className="contactGallery_row">
              <Lightbox
                currentImage={this.state.currentImage}
                images={imagesArray}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                onClose={this.closeLightbox}
              />

              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[1]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[2]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[3]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[4]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[5]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[6]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[7]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[8]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[9]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[10]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[11]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_ov[12]}
                         alt="LLC"/></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    } else if (this.props.branchActive === 2) {

      let imgIndex = 0;

      let imagesArray = [];

      this.props.galleryImgs_om.forEach((img, index) => {
        if (index === 0) return;
        imagesArray.push({src: img})
      });

      return (
        <section className="contactGallery">
          <div className="container_1000">
            <div className="contactGallery_row">
              <Lightbox
                currentImage={this.state.currentImage}
                images={imagesArray}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                onClose={this.closeLightbox}
              />

              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[1]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[2]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[3]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[4]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[5]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[6]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[7]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[8]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[9]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[10]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[11]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_om[12]}
                         alt="LLC"/></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    } else if (this.props.branchActive === 3) {

      let imgIndex = 0;

      let imagesArray = [];

      this.props.galleryImgs_op.forEach((img, index) => {
        if (index === 0) return;
        imagesArray.push({src: img})
      });

      return (
        <section className="contactGallery">
          <div className="container_1000">
            <div className="contactGallery_row">
              <Lightbox
                currentImage={this.state.currentImage}
                images={imagesArray}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                onClose={this.closeLightbox}
              />

              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[1]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[2]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[3]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[4]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[5]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[6]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[7]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[8]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[9]}
                         alt="LLC"/></div>
                </div>
              </div>
              <div className="contactGallery_col">
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[10]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[11]}
                         alt="LLC"/></div>
                </div>
                <div className="contactGallery_item" id={imgIndex++} onClick={this.openLightbox.bind(this)}>
                  <div className="contactGallery_item_inner">
                    <img src={this.props.galleryImgs_op[12]}
                         alt="LLC"/></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    } else {
      return (<div/>)
    }
  };

  render() {
    return this.renderGallery();
  }
}

export default ContactGallery;


// WEBPACK FOOTER //
// ./src/components/Contact/ContactGallery/ContactGallery.js